let storySettings = require("../../../data/story_settings.sheet.json");
storySettings = storySettings[0]

let ConvertTimestamp = (timestamp) =>{
    let market_key = storySettings.Market_Key
    let timezoneIncrement = 0
    switch(market_key){
        case "SanAntonio":
            timezoneIncrement = 6;
            break;
        case "Houston":
            timezoneIncrement = 6;
            break;
        case "Texcom":
            timezoneIncrement = 6;
            break;
        case "Albany":
            timezoneIncrement = 5;
            break;
        case "CT":
            timezoneIncrement = 5;
            break;
        case "Midcom":
            timezoneIncrement = 5;
            break;
        case "SFC":
                timezoneIncrement = 8;
            break;
    }
    let today = new Date()
    let hourUnit = 3600000
    console.log(hourUnit * timezoneIncrement)
    console.log(timestamp)
    return(timestamp + (hourUnit * timezoneIncrement))
}
  export { ConvertTimestamp }